// extracted by mini-css-extract-plugin
export default {"wrapper":"WizardDesignTemplateItem_wrapper__7w8tf","text":"WizardDesignTemplateItem_text__STx4y"};